import { useEffect } from "react";
import { faqs } from "@/mocks/faqs";
import { categories } from "@/mocks/categories";

export default function SeoJsonLd() {
  useEffect(() => {
    const scripts = [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "吃瓜视频内容分类",
        itemListElement: categories.map((c, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: c.name,
          description: c.desc,
        })),
      },
    ];

    const nodes = scripts.map((data) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.text = JSON.stringify(data);
      el.setAttribute("data-jsonld", "page");
      document.head.appendChild(el);
      return el;
    });

    return () => {
      nodes.forEach((n) => n.remove());
    };
  }, []);

  return null;
}